import React from 'react';
import { IconButton } from '../../../components/buttons';
import styles from './action-card-list-item.module.css';
import classNames from 'classnames';
export function ActionCardListItem(_a) {
    var action = _a.action, description = _a.description, title = _a.title;
    return (React.createElement("div", { className: classNames('card', 'glass', styles.actionCardListItemWrapper, "kplr_actionCardListItemWrapper") },
        React.createElement("div", { className: styles.actionCardListItemInner },
            React.createElement("div", { className: styles.actionCardListItemContent },
                React.createElement("p", { className: classNames('body1', styles.contentTitle) }, title),
                React.createElement("p", { className: "body2" }, description)),
            React.createElement("div", { className: styles.actionCardListItemActions },
                React.createElement(IconButton, { iconType: action.iconType, borderRadius: "10px", borderWidth: 2, borderColour: "borders", onClick: action.onClick }, action.icon)))));
}
export default ActionCardListItem;
